import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import pt from 'date-fns/locale/pt';
import { makeStyles } from '@material-ui/core/styles';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import LeftArrowIcon from '@material-ui/icons/KeyboardArrowLeft';
import RightArrowIcon from '@material-ui/icons/KeyboardArrowRight';
import CalendarToday from '@material-ui/icons/DateRange';


const CustomDatePicker = (props) => {
// const getColor = () => (props.color ? props.color : 'inherit');

  const useStyles = makeStyles({
    root: {
      '& label': {
        color: 'white',
      },
      '& input': {
        color: 'white',
      },
      '& button': {
        color: 'white',
      },
      '& div::before': {
        borderColor: 'white',
      },
    },
  });

  const customStyles = useStyles();

  const classes = {
    root: customStyles.root,
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={pt}>
      <KeyboardDatePicker
        {...props}
        classes={props.color && {
          root: classes.root,
        }}
        invalidDateMessage="Data inválida"
        leftArrowIcon={<LeftArrowIcon />}
        rightArrowIcon={<RightArrowIcon />}
        keyboardIcon={<CalendarToday />}
        cancelLabel="Cancelar"
        okLabel="Confirmar"
        format="dd/MM/yyyy"
        placeholder="dd/mm/aaaa"
        mask="__/__/____"
        onChange={props.onChange}
        onBlur={props.onBlur}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}
      />
    </MuiPickersUtilsProvider>
  );
};
export default CustomDatePicker;

